
import { useState } from 'react';
import { YoungSchemasResult } from '@/types/personality';
import EnhancedAdvancedAnalysisCard from './EnhancedAdvancedAnalysisCard';
import YoungSchemasAdvancedAnalysisModal from './YoungSchemasAdvancedAnalysisModal';

interface YoungSchemasAdvancedAnalysisButtonProps {
  results: YoungSchemasResult;
  onAnalysisComplete?: (analysis: string, insightId: string) => void;
}

export default function YoungSchemasAdvancedAnalysisButton({ 
  results, 
  onAnalysisComplete 
}: YoungSchemasAdvancedAnalysisButtonProps) {
  const [analysis, setAnalysis] = useState<string>('');
  const [insightId, setInsightId] = useState<string>('');
  const [showModal, setShowModal] = useState(false);

  const handleAnalysisComplete = (result: any) => {
    if (result?.analysis && result?.insightId) {
      setAnalysis(result.analysis);
      setInsightId(result.insightId);
      setShowModal(true);
      
      if (onAnalysisComplete) {
        onAnalysisComplete(result.analysis, result.insightId);
      }
    }
  };

  const analysisData = {
    youngSchemaResults: {
      emotional_deprivation: results.emotional_deprivation,
      abandonment: results.abandonment,
      mistrust_abuse: results.mistrust_abuse,
      social_isolation: results.social_isolation,
      defectiveness: results.defectiveness,
      failure: results.failure,
      dependence: results.dependence,
      vulnerability: results.vulnerability,
      enmeshment: results.enmeshment,
      entitlement: results.entitlement,
      insufficient_self_control: results.insufficient_self_control,
      subjugation: results.subjugation,
      self_sacrifice: results.self_sacrifice,
      approval_seeking: results.approval_seeking,
      negativity: results.negativity,
      emotional_inhibition: results.emotional_inhibition,
      unrelenting_standards: results.unrelenting_standards,
      punitiveness: results.punitiveness,
      timestamp: results.timestamp
    }
  };

  const features = [
    'Análise detalhada dos 18 esquemas',
    'Identificação de domínios predominantes',
    'Padrões emocionais disfuncionais',
    'Estratégias de enfrentamento específicas',
    'Recomendações terapêuticas direcionadas',
    'Plano de trabalho com esquemas centrais',
    'Técnicas de reestruturação cognitiva',
    'Orientações para mudança comportamental'
  ];

  return (
    <>
      <EnhancedAdvancedAnalysisCard
        title="Análise Avançada - Esquemas de Young"
        description="Receba insights personalizados sobre seus esquemas emocionais e recomendações terapêuticas específicas"
        cost={30}
        data={analysisData}
        functionName="young-schemas-advanced-analysis"
        onAnalysisComplete={handleAnalysisComplete}
        estimatedTime="2-3 min"
        features={features}
      />

      {showModal && (
        <YoungSchemasAdvancedAnalysisModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          analysis={analysis}
          insightId={insightId}
        />
      )}
    </>
  );
}
